import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { FormBuilder, Validators, FormGroup, AbstractControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { faPaperPlane,faArrowLeft, faPhoneAlt, faUser, faEnvelope, faKey, faMapMarkedAlt } from '@fortawesome/free-solid-svg-icons';
import { Router } from '@angular/router';
import { AuthenticationService, UserService } from '@app/_services';
import { Registration } from '@app/interface/request.interface';
import { environment } from '@environments/environment';

@Component({
    selector: 'app-registration',
    templateUrl: './registration.component.html',
    styleUrls: ['./registration.component.css'],
    standalone: false
})
export class RegistrationComponent implements OnInit {
  registrationForm! : FormGroup;
  loading = false;
  submitted = false;
  error = '';

  faPaperPlane = faPaperPlane;
  faArrowLeft = faArrowLeft;
  faPhoneAlt = faPhoneAlt;
  faUser = faUser;
  faEnvelope = faEnvelope;
  faKey = faKey;
  faMapMarkedAlt = faMapMarkedAlt;

  emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$";
  passwordPattern = "^[a-zA-Z0-9@!#$*]{5,30}$";
  fullNamePattern = "^[A-Za-z -]{5,40}[A-Za-z -]+";
  usernamePattern = '[a-zA-Z][a-zA-Z0-9-_]{2,30}';
  addressPattern = "^[A-Za-z0-9 -,-]+[A-Za-z0-9,]+";
  lotPattern = "^[0-9A-Za-z]{1,5}";

  constructor(        private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private router: Router,
    private _location: Location,
    private userService: UserService,
    private authenticationService: AuthenticationService) { }



  ngOnInit() {

    this.registrationForm = this.formBuilder.group({
      username: ['', [Validators.required, Validators.pattern(this.usernamePattern)]],
      fullname: ['', [Validators.required, Validators.pattern(this.fullNamePattern)]],
      email: ['', [Validators.required, Validators.pattern(this.emailPattern)]],
      phone: ['', [Validators.required, Validators.minLength(10)]],
      blockname: [''],
      address: ['', [Validators.required, Validators.pattern(this.addressPattern)]],
      apartmentnumber: ['', [Validators.required]],
      password: ['', [Validators.required,  Validators.minLength(5), Validators.pattern(this.passwordPattern)]],
      confirmPassword: ['', [Validators.required, Validators.minLength(5), Validators.pattern(this.passwordPattern)]]
    });
  }

  goBack() {
    this._location.back();
  }

  get f() { return this.registrationForm.controls; }

  get userEmail() {
    return this.registrationForm.get('email');
  }

  onPasswordChange() {
    if (this.confirm_password.value == this.password.value) {
      this.confirm_password.setErrors(null);
    } else {
      this.confirm_password.setErrors({ mismatch: true });
    }
  }
  
  // getting the form control elements
  get password(): AbstractControl {
    return this.registrationForm.controls['password'];
  }
  
  get confirm_password(): AbstractControl {
    return this.registrationForm.controls['confirmPassword'];
  }

  onSubmit() {
    this.submitted = true;
    
    if (!environment.production) {
      console.log('Is form invalid: ', this.registrationForm.invalid);
      console.log('Form object: ', this.registrationForm);
    }
    

    // stop here if form is invalid
    //|| this.registrationForm.get('username').errors == null ||
    //    this.registrationForm.get('email').errors == null
    if (this.registrationForm.invalid) 
    {
        return;
    }

    var data = this.registrationForm.value;
    let reqjson: Registration =  {
      fullname: data.fullname,
      username: data.username,
      address: data.address,
      address2: data.blockname + ', ' + data.apartmentnumber,
      blockname: data.blockname,
      apartmentnumber: data.apartmentnumber,
      phone: data.phone,
      email: data.email,
      password: data.password
    };

    this.loading = true;

    this.userService.registerUser(reqjson).subscribe(
      data => {
        if (data.messageCode == 'CREATED') {
          this.toastr.success(data.message, 'Success');
          this.router.navigate(['/login']);
        }
        else {
          this.toastr.warning(data.message, 'Information');
        }
      
        this.loading = false;
      },
      error => {
        this.toastr.error(error.message, 'Error');
        this.loading = false;
      }

    );




  }

}
